import {Component, Input} from '@angular/core';
import {QuestionItem} from "../../models/question-item.model";
import {DistributionItem} from "../../models/distribution-item.model";
import {DecimalPipe, NgClass, NgForOf} from "@angular/common";
import {QuestionType} from "../popups/question-list/question-type.enum";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-distribution-circle',
  standalone: true,
  imports: [
    NgForOf,
    NgClass,
    DecimalPipe,
    TranslocoPipe
  ],
  templateUrl: './distribution-circle.component.html',
  styleUrl: './distribution-circle.component.scss'
})
export class DistributionCircleComponent {
  @Input() public set data(value: QuestionItem[]) {
    this._data = value;
    this.getDistribution();
  };
  protected distribution: DistributionItem[] = []
  private _data: QuestionItem[] = [];

  protected setClass(state: QuestionType): string {
    switch (state) {
      case QuestionType.Ok:
        return 'ok';
      case QuestionType.Nok:
        return 'nok';
      case QuestionType.NotRelevant:
        return 'not-relevant';
      case QuestionType.Unknown:
        return 'unknown';
    }
  }

  protected setDisplayName(state: QuestionType): string {
    switch (state) {
      case QuestionType.Ok:
        return 'STATES.OK'
      case QuestionType.Nok:
        return 'STATES.NOK'
      case QuestionType.NotRelevant:
        return 'STATES.NOT-RELEVANT'
      case QuestionType.Unknown:
        return 'STATES.UNKNOWN'
    }
  }

  protected calcOffset(index: number): number {
    if (index) {
      return this.distribution.map(d => d.amount).slice(0, index).reduce((sum, v) => sum + v) * -100;
    }
    return 0;
  }

  protected getDistribution(): DistributionItem[] {
    let sum = this._data.length;
    let options = this._data.map(x => x.state).filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => a - b);
    this.distribution = options.map(x => ({type: x, amount: 0} as DistributionItem));
    this.distribution.forEach(d => d.amount = (this._data.filter(x => x.state === d.type).length)/sum)

    return this.distribution;
  }

  protected readonly toString = toString;
}
